import {Component, OnInit} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import {ToasterService} from 'angular2-toaster';
import {GeneralConstants} from '../../shared/general.constants';
import * as _ from 'lodash';
import {VideoService} from '../model/video.service';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';

const PAGE_SIZE = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'talent-video-search',
    templateUrl: 'talent-video-search.component.html',
    styleUrls: ['talent-video-search.component.scss']
})
export class TalentVideoSearchComponent implements OnInit {

    private SEARCH_QUERY_OBJECT = {
        'page': '',
        'size': '',
        'query': {
            'catalog_state': '',
            'classification_type': ''
        },
        'sort_direction': '',
        'sort_by': ''
    };

    private checkboxes = {
        clientReady: true,
        demandGeneration: true,
        harvested: false,
        requested: false,
    };
    private shouldDoSearch = false;

    private sortNSearchCriteriaCheckboxes = {
        byDate: true,
        byParrotid: false,
        byTitle: false,
        sortState: true,
        sortDirection: true
    };
    private byParrotIdSearch = '';
    private byTitleSearch = '';
    private catalogStates = ['client_ready', 'demand_generation'];
    private sortValues = ['Total Number of Views', 'Total Number of Videos', 'Total Number of Unverified Videos'];
    private sortDirectionValues = ['Descending', 'Ascending'];
    private sortByState = 'TOTAL_NUMBER_OF_VIEWS';
    private sortDirectionValue = 'descending';
    private contentType = 'TALENT';
    private totalResults = 0;


    private page = 0;
    private maxPages;


    private subject = new Subject<string>();
    private searchValue = '';
    private results = [];

    private selectedShow;

    private hasMore = false;
    private categoryType: number = 1;
    private classificationType: number = 1;
    private classificationTypeValue = 'PERSONAL';

    private startDate = new Date();
    private endDate = new Date();
    private loadingVideos = false;


    constructor(private videoService: VideoService, private catalogService: CatalogService, private toasterService: ToasterService) {

        this.startDate = new Date(this.startDate.setDate(this.startDate.getDate() - 366));
        this.endDate = new Date(this.endDate.setDate(this.endDate.getDate() + 366));
    }

    ngOnInit() {
    }

    handleLoadMore() {
        this.page = this.page + 1;
        this.handleSubmit();
    }

    handleCatalogStateCheckbox(checkboxName, checked: any) {

        this.catalogStates = [];

        if (checked) {
            this.catalogStates.push(checkboxName);
        }
    }

    handleOriginalFiltersCheckboxes(checkboxName) {
        this.sortNSearchCriteriaCheckboxes[checkboxName] = !this.sortNSearchCriteriaCheckboxes[checkboxName];
        if (this.shouldSearch()) {
            switch (checkboxName) {
                case 'byParrotid':
                    this.sortNSearchCriteriaCheckboxes['byTitle'] = false;
                    if (this.byParrotIdSearch && this.byParrotIdSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'byTitle':
                    this.sortNSearchCriteriaCheckboxes['byParrotid'] = false;
                    if (this.byTitleSearch && this.byTitleSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'catalogState':
                    if (this.sortByState && this.sortByState !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
            }
        } else {
            this.results = [];
        }
    }

    handleOpen(result) {

        if (!this.selectedShow || (this.selectedShow && this.selectedShow.parrot_id !== result.parrotId)) {
            this.selectedShow = {
                parrot_id: result.parrot_id,
                title: result.title,
                displayName: result.displayName,
                catalog_state: result.catalogState,
                primary_occupation: result.primary_occupation,
                birth_date: result.birth_date,
                birth_year: result.birth_year,
                imdb_id: result.imdb_id,
                wikibase_id: result.wikibase_id,
            };
        } else if (this.selectedShow && this.selectedShow.parrot_id === result.parrotId) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: undefined,
                    catalog_state: 'client_ready',
                    title: undefined,
                    content_type: undefined,
                    display_name: undefined
                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: result.parrot_id,
                    title: result.title,
                    displayName: result.displayName,
                    catalog_state: result.catalog_state,
                    primary_occupation: result.primary_occupation,
                    birth_date: result.birth_date,
                    birth_year: result.birth_year,
                    imdb_id: result.imdb_id,
                };
            });
        }
    }

    onKeyUp(searchValue) {
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }

    onOriginalKeyUp(value, type) {
        switch (type) {
            case 'byParrotid':
                this.byParrotIdSearch = value;
                this.handleSubmit();
                break;
            case 'byTitle':
                this.byTitleSearch = value;
                this.handleSubmit();
                break;
            case 'byDate':
                break;
            case 'sortState':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if (value === 'Release Date') {
                        value = 'release_date';
                    } else if (value === 'Total Number of Videos') {
                        value = 'TOTAL_NUMBER_OF_VIDEOS';
                    } else if (value === 'Total Number of Views') {
                        value = 'TOTAL_NUMBER_OF_VIEWS';
                    } else if (value === 'Total Number of Unverified Videos') {
                        value = 'TOTAL_NUMBER_OF_UNVERIFIED_VIDEOS';
                    }
                    this.sortByState = value;
                }
                break;
            case 'sortDirection':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if (value === 'Ascending') {
                        value = 'ascending';
                    } else if (value === 'Descending') {
                        value = 'descending';
                    }
                    this.sortDirectionValue = value;
                }
                break;
        }
    }

    shouldSearch() {
        return this.searchValue || (this.sortNSearchCriteriaCheckboxes.byDate ||
            this.sortNSearchCriteriaCheckboxes.byParrotid || this.sortNSearchCriteriaCheckboxes.byTitle);
    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleGoToPage(page) {
        this.page = page;
    }

    handleSubmit() {

        this.results = [];
        this.loadingVideos = true;

        if ( this.sortNSearchCriteriaCheckboxes.byParrotid ) {
            this.getBySearchTerm('parrot_id', this.byParrotIdSearch);
        } else if ( this.sortNSearchCriteriaCheckboxes.byTitle ) {
            this.getBySearchTerm('title', this.byTitleSearch);
        } else {
            this.getBySearchQuery();
        }
    }

    async getBySearchTerm(searchType, searchTerm) {


        try {
            const response = await this.videoService.getBySearchTerm(
                searchType, this.contentType, searchTerm, this.classificationTypeValue);
            this.results = this.results.concat(response.result.map(item => this.videoService.mapTalentResultItem(item)));
            this.totalResults = 0;
            if (this.totalResults > (this.page)) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
            this.loadingVideos = false;
        } catch (err) {
            console.error('Failed to get video results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get video results');
            this.loadingVideos = false;
        }
    }

    async getBySearchQuery() {

        try {
            const searchQuery = this.createSearchQuery();
            const response = await this.videoService.getBySearchQuery(
                searchQuery, this.contentType);

            this.results = this.results.concat(response.result.map(item => this.videoService.mapTalentResultItem(item)));
            this.totalResults = response.page_info.maxpage - 1;
            if (this.totalResults > (this.page)) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
            this.loadingVideos = false;
        } catch (err) {
            console.error('Failed to get video results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get video results');
            this.loadingVideos = false;
        }
    }

    createSearchQuery() {
        const requestQuery = _.cloneDeep(this.SEARCH_QUERY_OBJECT);
        requestQuery.page = this.page;
        requestQuery.size = PAGE_SIZE;

        requestQuery.query.catalog_state = this.catalogStates;
        requestQuery.query.classification_type = this.classificationTypeValue;
        requestQuery.sort_by = this.sortByState;
        requestQuery.sort_direction = this.sortDirectionValue;

        // console.log(JSON.stringify(requestQuery));
        return JSON.stringify(requestQuery);


    }

    onClassificationTypeChange(value: number) {
        this.classificationType = value;

        if (value === 1) {
            this.classificationTypeValue = 'PERSONAL';
        } else {
            this.classificationTypeValue = 'PROFESSIONAL';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/talent-video-search/talent-video-search.component.ts